var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoiteringCustomEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51722 16.6673L7.77648 13.7044L6.29499 11.4821V7.03769M6.29499 7.03769L3.33203 9.25991L4.07277 10.7414M6.29499 7.03769L8.51722 8.51917L9.9987 8.88954M5.55425 13.7044L4.07277 16.6673M5.55425 4.07473C5.55425 4.27118 5.6323 4.45959 5.77121 4.59851C5.91013 4.73742 6.09854 4.81547 6.29499 4.81547C6.49145 4.81547 6.67986 4.73742 6.81878 4.59851C6.95769 4.45959 7.03574 4.27118 7.03574 4.07473C7.03574 3.87827 6.95769 3.68986 6.81878 3.55094C6.67986 3.41203 6.49145 3.33398 6.29499 3.33398C6.09854 3.33398 5.91013 3.41203 5.77121 3.55094C5.6323 3.68986 5.55425 3.87827 5.55425 4.07473Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1852 16.6673L14.4444 13.7044L12.963 11.4821V7.03769M12.963 7.03769L10 9.25991L10.7407 10.7414M12.963 7.03769L15.1852 8.51917L16.6667 8.88954M12.2222 13.7044L10.7407 16.6673M12.2222 4.07473C12.2222 4.27118 12.3003 4.45959 12.4392 4.59851C12.5781 4.73742 12.7665 4.81547 12.963 4.81547C13.1594 4.81547 13.3478 4.73742 13.4867 4.59851C13.6257 4.45959 13.7037 4.27118 13.7037 4.07473C13.7037 3.87827 13.6257 3.68986 13.4867 3.55094C13.3478 3.41203 13.1594 3.33398 12.963 3.33398C12.7665 3.33398 12.5781 3.41203 12.4392 3.55094C12.3003 3.68986 12.2222 3.87827 12.2222 4.07473Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoiteringCustomEvent);
export default __webpack_public_path__ + "static/media/LoiteringCustomEvent.5c5ed25d1ed6ad758fe9f50aec3ae7fb.svg";
export { ForwardRef as ReactComponent };